import { supabase } from '@/integrations/supabase/client';

// Toggleable privacy flag. In dev/testing keep false (public bucket + anon writes).
// In production, set VITE_STORAGE_PRIVATE=true and update Storage policies
// to use private buckets + authenticated writes.
const IS_PRIVATE = (import.meta as any)?.env?.VITE_STORAGE_PRIVATE === 'true';

export async function getObjectUrl(bucket: string, path: string): Promise<string> {
  if (!IS_PRIVATE) {
    const { data } = supabase.storage.from(bucket).getPublicUrl(path);
    return data?.publicUrl || '';
  }
  const { data, error } = await supabase.storage.from(bucket).createSignedUrl(path, 60 * 60);
  if (error) return '';
  return data.signedUrl;
}

